import { boolean } from "yup";

import { Translate } from "@/redux/modules/value/translations/translations.provider";

const ageCondition = boolean().oneOf(
    [true],
    () => () => (t: Translate) =>
        t("checkout.customerDetails.ageCondition.validation.input.required")
);
const partnerCondition = boolean().oneOf(
    [true],
    () => () => (t: Translate) =>
        t("checkout.customerDetails.partnerCondition.validation.input.required")
);

export const Conditions = {
    ageCondition: ageCondition,
    partnerCondition: partnerCondition
};
